export default __webpack_public_path__ + "static/media/644.418d42ee.png";